.div_detail {
	background-color: white;
	padding-left: 10px;
	padding-right: 10px;
	border-radius: 10px;
	min-height: 12vh;
	min-width: 24vh;
	text-align: left;
	font-style: normal;
	color: black;
	font-weight: 400;

	.title {
		font-size: 14px;
		font-weight: 500;
		color: #7fb02f;
		border-bottom: 2px solid #7fb02f;
	}

	.table {
		width: 100%;

		td {
			border-bottom: 0.5px solid #9e9e9e;
			padding-top: 5px;
			padding-bottom: 5px;
		}
	}
}
